module.exports = __webpack_public_path__ + "static/media/github.8b818ad1.png";